import React from "react";
import { Link } from "react-router-dom";
import styles from "./NotFound.module.css"; // Assume you create this CSS module for styling

const NotFound = () => {
  return (
    <div className={styles.notFoundContainer}>
      <h1>404 - Strona nie została znaleziona</h1>
      <Link to="/" className={styles.homeLink}>
        Wróć do strony głównej
      </Link>
    </div>
  );
};

export default NotFound;
